/************************************************************************************
 *
 *************************************************************************************/
function l_formatMoney(cents, format = '') {
	let value = ''
	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
	const formatString = format || window.themeVariables.settings.moneyFormat

	if (typeof cents == 'string') {
		cents = cents.replace('.', '')
	}

	function defaultOption(opt, def) {
		return typeof opt == 'undefined' ? def : opt
	}

	function formatWithDelimiters(number, precision, thousands, decimal) {
		precision = defaultOption(precision, 2)
		thousands = defaultOption(thousands, ',')
		decimal = defaultOption(decimal, '.')

		if (isNaN(number) || number == null) {
			return 0
		}

		number = (number / 100.0).toFixed(precision)

		var parts = number.split('.'),
			dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
			cents = parts[1] ? decimal + parts[1] : ''

		return dollars + cents
	}

	switch (formatString.match(placeholderRegex)[1]) {
		case 'amount':
			value = formatWithDelimiters(cents, 2)
			break
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0, ' ', '.')
			break
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', '.')
			break
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', '.')
			break
	}

	return formatString.replace(placeholderRegex, value)
}

/************************************************************************************

* [PRODUCT PAGE]: Selected Variant Price
* [DESCRIPTION]: Display the price of the selected variant in the product page ATC button
* [USAGE]: <l-selected-variant-price></l-selected-variant-price>

*************************************************************************************/
if (!customElements.get('l-product-estimated-shipping')) {
	class LProductEstimatedShipping extends HTMLElement {
		constructor() {
			super()
		}

		connectedCallback() {
			// Data
			this.minDate = Number(this.dataset.minDate)
			this.maxDate = Number(this.dataset.maxDate)
			this.deliveryText = this.dataset.deliveryText

			if (!this.deliveryText) return

			// Elements
			this.textEl = this.querySelector('[data-text]')

			console.log(this.deliveryText)
			console.log(this.textEl)

			// Update text
			const minDate = this.calculateDeliveryDate(this.minDate)
			const maxDate = this.calculateDeliveryDate(this.maxDate)

			const options = { month: 'long', day: 'numeric' }
			const minDateString = minDate.toLocaleDateString(undefined, options)
			const maxDateString = maxDate.toLocaleDateString(undefined, options)

			this.textEl.innerHTML = this.deliveryText
				.replace('[date_min]', minDateString)
				.replace('[date_max]', maxDateString)
		}

		calculateDeliveryDate(daysToAdd) {
			const date = new Date()

			while (daysToAdd > 0) {
				date.setDate(date.getDate() + 1)
				if (date.getDay() !== 0 && date.getDay() !== 6) {
					daysToAdd--
				}
			}

			return date
		}
	}

	customElements.define('l-product-estimated-shipping', LProductEstimatedShipping)
}

class VideoSliderBlock extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    var blockSlider = this.querySelector('.product-custom-video-slider');
	var popupSlider = this.querySelector('.video-slider-block-popup-slider');
	if (blockSlider) {
		const swiperBlock = new Swiper(blockSlider, {
			slidesPerView: 3.2,
			spaceBetween: 12,
			breakpoints: {
				700: {
					slidesPerView: 3.8,
					spaceBetween: 16
				}
			}
		});
	}

	if (popupSlider) {
		const swiperPopup = new Swiper(popupSlider, {
			slidesPerView: 1,
			spaceBetween: 20,
			navigation: {
				nextEl: '.custom-swiper-button-next',
				prevEl: '.custom-swiper-button-prev',
			}
		});

		swiperPopup.on('slideChange', function () {
			var allVideos = this.el.querySelectorAll('.video-slider-block-popup-slider-item-video video');
			var curentVideo = swiperPopup.slides[swiperPopup.activeIndex].querySelector('.video-slider-block-popup-slider-item-video video');
			if (allVideos.length) {
				allVideos.forEach(function(video) {
					video.pause();
				});
			}
			if (curentVideo) {
				curentVideo.play();
			}
		});
	}
  }
}

customElements.define("video-slider-block", VideoSliderBlock);

class CustomReviews extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    var blockSlider = this.querySelector('.product-custom-reviews-slider');

	if (blockSlider) {
		const swiper = new Swiper(blockSlider, {
			slidesPerView: 1,
			spaceBetween: 0,
			navigation: {
				nextEl: '.product-custom-reviews-button-next',
				prevEl: '.product-custom-reviews-button-prev',
			}
		});
	}
  }
}

customElements.define("custom-reviews", CustomReviews);

